import { boolean, InferType, number, object, string } from 'yup';
import { includes } from 'lodash/fp';
import { messageDefaults } from '@ahmdigital/form-validation';
import { SCALE } from '@ahmdigital/constants';

const { integer, minAge, minAgePartner, required, validAge } = messageDefaults;

const refinePriceSchema = object({
  age: number()
    .typeError(integer)
    .required('Enter your age')
    .positive()
    .integer(integer)
    .min(16, minAge)
    .max(120, validAge),
  frequency: string().required(required),
  incomeTier: string().required(required),
  incomeType: string().required(required),
  partnerAge: number()
    .typeError(integer)
    .nullable()
    .when('scale', {
      is: (value: string) => !includes(value, [SCALE.SINGLE, SCALE.SINGLE_PARENT]),
      then: (rule) =>
        rule.required('Enter your partner’s age').integer(integer).min(16, minAgePartner).max(120, validAge),
    }),
  productType: string().required('Choose a health cover type'),
  rebate: boolean().required(required),
  scale: string().required(required),
  state: string().required(required),
});

export type RefinePriceSchemaType = InferType<typeof refinePriceSchema>;

export default refinePriceSchema;
